import { AppState } from '../../rootReducer';

export const getEmailCampaignsList = (state: AppState) => state.emailMarketing.campaigns.list;
export const getEmailCampaignsListLoading = (state: AppState) => state.emailMarketing.campaigns.loading;
export const getEmailCampaignsListFetched = (state: AppState) => state.emailMarketing.campaigns.fetched;
export const getEmailCampaignsDetails = (state: AppState) => state.emailMarketing.campaigns.details;
export const getDeletedCampaign = (state: AppState) => state.emailMarketing.campaigns.deletedCampaign;
